import Button from "Components/Common/Button/Button";
import type { SessionData } from "hooks/useProfile";

interface Props {
  sessions: SessionData[];
  onRevoke: (id: string) => void;
  onRevokeAll: () => void;
}

export default function ActiveSessionsSection({
  sessions,
  onRevoke,
  onRevokeAll,
}: Props) {
  return (
    <div>
      <div className="pf-section-head">
        <h2>Active Sessions</h2>
        <p>Devices currently logged in to your CSC account.</p>
      </div>

      <div className="pf-card">
        <div className="pf-card__title">
          Devices
          <Button
            type="button"
            className="pf-btn-secondary pf-btn-sm"
            onClick={onRevokeAll}
          >
            Revoke All Others
          </Button>
        </div>

        {sessions.map((session) => (
          <div key={session.id} className="pf-session-row">
            <div
              className={`pf-session-icon${session.isCurrent ? " current" : ""}`}
            >
              {session.icon}
            </div>
            <div className="pf-session-info">
              <div className="pf-session-device">{session.device}</div>
              <div className="pf-session-meta">
                {session.location && <>{session.location} · </>}
                Last active: {session.lastActive}
              </div>
            </div>
            {session.isCurrent === true ? (
              <span className="pf-session-badge">This device</span>
            ) : (
              <Button
                type="button"
                className="pf-session-revoke"
                onClick={() => onRevoke(session.id)}
              >
                Revoke
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
